import type { CSSProperties } from 'react'
import { Button } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'

type OnboardingPageDesktopProps = {
  onContinue: () => void
  renewalSummaryLine: string
  reminderLine: string
}

const desktopTokens = designTokens.components.onboardingSuccess.desktop
const cardTokens = desktopTokens.card

const titleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.onboarding.titleDesktop, {
    fontSize: '28px',
    lineHeight: 'normal',
  }),
}

const subtitleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.md, {
    lineHeight: '130%',
  }),
}

const cardStyle: CSSProperties = {
  width: cardTokens.width,
  minHeight: cardTokens.height,
  borderRadius: cardTokens.borderRadius,
  padding: cardTokens.padding,
  borderColor: cardTokens.borderColor,
  borderWidth: designTokens.borders.widths.thin,
  borderStyle: designTokens.borders.styles.solid,
  background: cardTokens.background,
  boxShadow: cardTokens.shadow,
  backdropFilter: `blur(${cardTokens.backdropBlur})`,
  WebkitBackdropFilter: `blur(${cardTokens.backdropBlur})`,
}

const cardTitleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  ...typographyStyle(designTokens.typography.body.lg, {
    fontWeight: 600,
  }),
}

const cardBodyStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.inverse,
  opacity: Number(cardTokens.textOpacity),
  ...typographyStyle(designTokens.typography.body.sm, {
    lineHeight: 'normal',
  }),
}

export function OnboardingPageDesktop({
  onContinue,
  renewalSummaryLine,
  reminderLine,
}: OnboardingPageDesktopProps) {
  return (
    <div className="relative hidden h-full w-full flex-1 xl:block">
      <div
        className="relative mx-auto h-full w-full"
        style={{ maxWidth: desktopTokens.frameWidth, height: '100%' }}
      >
        <div
          className="relative z-10 flex h-full flex-col"
          style={{
            width: desktopTokens.contentWidth,
            paddingLeft: desktopTokens.contentOffsetX,
            paddingTop: desktopTokens.contentOffsetTop,
          }}
        >
          <h1 style={titleStyle}>Теперь вам доступны все преимущества подписки</h1>
          <p style={{ ...subtitleStyle, marginTop: desktopTokens.subtitleGap }}>
            {renewalSummaryLine}
            <br />
            {reminderLine}
          </p>
          <div className="mt-7 flex" style={{ gap: desktopTokens.cardsGap }}>
            <article style={cardStyle}>
              <h2 style={cardTitleStyle}>База знаний</h2>
              <p style={{ ...cardBodyStyle, marginTop: cardTokens.titleBodyGap }}>
                Экспертные доклады про рост метрик, маркетинг, дизайн, нейросети, управление
                командой - все, что поможет растить бизнес.
              </p>
            </article>
            <article style={cardStyle}>
              <h2 style={cardTitleStyle}>
                Бот комьюнити
                <br />и нетворкинг
              </h2>
              <p style={{ ...cardBodyStyle, marginTop: cardTokens.titleBodyGap }}>
                Мини-приложение с анкетами участников, чатом, Random Coffee и актуальными новостями.
              </p>
            </article>
          </div>
          <Button
            type="button"
            onClick={onContinue}
            variant="secondaryAssist"
            style={{
              marginTop: desktopTokens.buttonMarginTop,
              width: desktopTokens.button.width,
              minHeight: desktopTokens.button.height,
              borderRadius: desktopTokens.button.radius,
              backgroundColor: designTokens.colors.background.surface,
              color: designTokens.colors.neutral.ink,
              borderColor: designTokens.colors.background.transparent,
              ...typographyStyle(designTokens.typography.button),
            }}
          >
            Продолжить
          </Button>
        </div>
      </div>
    </div>
  )
}
